import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { handleResponseThrowError } from '@/_utils/services';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import type { Extract } from '../types';
import { GET_EXTRACTS_PLACES } from './constants';

type GetExtractsPlacesProps = {
  placeId: string;
  limit?: number;
  startDate?: string;
  endDate?: string;
  page?: number;
};

const getExtractsPlaces = (params: GetExtractsPlacesProps) => {
  const { placeId, startDate, endDate, limit, page } = params || {};

  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return apiClientOld
    .get<{
      limit: number;
      offset: number;
      results: Extract[];
      total_count: number;
    }>(`/estabelecimentos/${placeId}/bank/extrato`, {
      params: {
        dataInicio: startDate,
        dataFim: endDate,
        limit: newLimit,
        offset,
      },
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetExtractsPlacesData = Awaited<ReturnType<typeof getExtractsPlaces>>;

export const useGetExtractsPlaces = (
  params: GetExtractsPlacesProps,
  options: Omit<
    UseQueryOptions<
      GetExtractsPlacesData,
      unknown,
      GetExtractsPlacesData,
      (string | GetExtractsPlacesProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_EXTRACTS_PLACES, params],
    queryFn: () => getExtractsPlaces(params),
    ...options,
  });
};
